import React from 'react';
import SuggestedCompanies from '../../components/proStudent/SuggestedCompanies/SuggestedCompanies';

const SuggestedCompaniesPage = () => {
  return (
    <div>
      <SuggestedCompanies />
    </div>
  );
};

export default SuggestedCompaniesPage;